import React, { createContext, useState, useEffect } from 'react';

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [userLocation, setUserLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('userLocation');
    if (saved) {
      setUserLocation(JSON.parse(saved));
    } else {
      setUserLocation({ city: 'Mumbai', state: 'Maharashtra', country: 'IN' });
    }
    setLoading(false);
  }, []);

  const updateLocation = (location) => {
    setUserLocation(location);
    localStorage.setItem('userLocation', JSON.stringify(location));
  };

  return (
    <LocationContext.Provider value={{ userLocation, loading, updateLocation }}>
      {children}
    </LocationContext.Provider>
  );
};
